import EChartsDialog from '@/components/LineChart/index.vue'
import {getCategory1ListApi, getCategoryListApi} from "@/api/admin/categoryApi";
import {getGoodsChangePageApi, getGoodsPriceTrendApi, updateGoodsPriceApi, updateMarketPriceApi} from "@/api/admin/topicApi";


/**
 * 选品商品
 */
export const mixins = {
    name: "GoodsChange",
    components: {
        EChartsDialog
    },
    data() {
        return {
            dialog: false,
            item: {},
            firstPage: true,
            index: 0,
            total: 999,
            loading: false,
            goodsChangeDto: {
                topicId: "",
                goodsId: "",
                current: 1,
                size: 10,
                total: 999,
                isJd: 1,
                title: "",
                categoryId1Name: "",
                categoryId2Name: "",
                minProfitMargin: "",
                maxProfitMargin: "",
                commentOkCount: "",
                logisticsType: "",
            },
            categoryId1: [],
            categoryId2: [],
            goodsChangeVo: [],
            idArr: [],
            rate: 1.3,
            jdRate: 1,
            chartDialogVisible: false,
            chartData: {}
        };
    },
    methods: {
        async editPrice(item) {
            try {
                // 弹出输入框，预填当前价格
                const { value: newPrice } = await this.$prompt('请输入新的市场价', '修改价格', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^\d+(\.\d{1,2})?$/, // 验证数字格式（整数或两位小数）
                    inputErrorMessage: '请输入有效的价格（如：99.99）',
                    inputValue: item.price || '' ,// 预填当前价格（根据实际字段调整）
                    customClass: 'large-price-prompt', // 添加自定义类名
                });

                // 调用修改价格的API（替换原来的删除API）
                await updateMarketPriceApi({
                    goodsId: item.skuId,
                    topicId: this.item.id,
                    marketPrice: newPrice, // 传入新价格
                    isJd: item.isJd
                });
                this.$message.success('价格修改成功!');
                this.queryGetList(); // 刷新列表
            } catch (error) {
                // 用户点击取消或验证失败
                if (error === 'cancel' || error === 'close') return;

                // 处理API错误
                this.$message.error('修改失败: ' + (error.response?.data?.message || error.message));
                console.error('修改价格失败:', error);
            }
        },
        /**
         * 重新添加商品到选品库
         */
        async reAdd(item) {
            item.disPriceType = 1;
            item.disPrice = 0;
            item.goodsId = item.id;
            await updateGoodsPriceApi(item)
            this.queryGetList();
        },
        /**
         * 查看商品价格趋势
         */
        async viewPriceTrend(item) {
            let {data} = await getGoodsPriceTrendApi({skuId: item.skuId});
            this.chartData = {
                ...data,
                skuName: item.title
            };
            this.chartDialogVisible = true;
        },
        chartDialogVisibleFn(val){
            this.chartDialogVisible = val;
        },
        /**
         * 获取表格样式
         */
        tableRowClassName({row}) {
            if (row.changStatus == 1) {
                return 'success-row';
            }
            if (row.changStatus == 2) {
                return 'exit-row';
            }
        },
        /**
         *  放大图片
         */
        getSrcList(cardPicUrl) {
            if (cardPicUrl) {
                return cardPicUrl.split(',');
            }
        },
        /**
         * 初始化组件
         */
        open(item) {
            this.index = 0;
            this.item = item;
            this.goodsChangeDto.current = 1;
            this.goodsChangeDto.topicId = item.id;
            this.dialog = true;
            this.initCategory();
            this.queryGetList()
        },
        /**
         * 关闭弹窗事件
         */
        closeChange() {
            this.$emit("closeChange");
        },
        /**
         * 初始化分类
         */
        async initCategory() {
            let {data} = await getCategoryListApi();
            this.categoryId1 = data.categoryList;
        },
        /**
         * 获取二级分类
         */
        async getCategory1List() {
            let {data} = await getCategory1ListApi({
                name: this.goodsChangeDto.categoryId1Name, categoryLevel: 1
            });
            this.goodsChangeDto.categoryId2Name = ""
            this.categoryId2 = data.categoryList;
            this.queryGetList()
        },
        /**
         * 条件查询
         */
        queryGetList() {
            this.getList()
        },
        /**
         * 获取选择商品ID
         * @param val
         */
        handleSelectionChange(val) {
            this.idArr = val.map(item => item.id)
        },
        /**
         * 分页大小切换时触发
         * @param val
         */
        handleSizeChange(val) {
            this.goodsChangeDto.size = val;
            this.getList();
        },
        /**
         * 页码切换时触发
         * @param val
         */
        handleCurrentChange(val) {
            this.goodsChangeDto.current = val;
            this.getList();
        },
        /**
         * 查询
         */
        async getList() {
            this.loading = true;
            let config = {
                ...this.goodsChangeDto,
                sortOrder: this.goodsChangeDto.sortOrder ? this.goodsChangeDto.sortOrder.join(',') : ''
            }
            let obj = JSON.parse(JSON.stringify(config));
            let {data: res} = await getGoodsChangePageApi(obj)
            this.goodsChangeVo = res.rows;
            // let {data} = await getSelectedTotalApi(obj)
            this.total = res.total;
            this.loading = false;
        },
        /**
         * 重置
         */
        reset() {
            this.goodsChangeDto = {
                commentType: "",
                goodsId: "",
                current: 1,
                size: 10,
                total: 999,
                isJd: 1,
                title: "",
                categoryId1Name: "",
                categoryId2Name: "",
                level: "",
                phone: "",
                minSupplyPrice: "",
                maxSupplyPrice: "",
                minProfitMargin: "",
                maxProfitMargin: "",
            }
            this.queryGetList();
        }
    },
    mounted() {

    }
}